import {get, post} from 'Utils/apiUtil';
import {callApi} from 'Utils/apiUtil';
import {
    getStManagementListUrl,
    queryShipToBySupplyCenterListUrl,
    getTransportMethodUrl,
    saveStApplyChangeUrl,
} from 'Utils/urlUtil';

export const GET_ST_MANAGEMENT_LIST = 'GET_ST_MANAGEMENT_LIST';
export const CLEAR_ST_MANAGEMENT_LIST = 'CLEAR_ST_MANAGEMENT_LIST';

export const clearStManagementList = () => ({type: CLEAR_ST_MANAGEMENT_LIST});
export const GET_ST_APPLY_CHANGE_SUPPLY_CENTER_LIST =
    'GET_ST_APPLY_CHANGE_SUPPLY_CENTER_LIST';
export const GET_ST_TRANSPORT_METHOD_LIST = 'GET_ST_TRANSPORT_METHOD_LIST';
export const SAVE_ST_APPLY_CHANGE = 'SAVE_ST_APPLY_CHANGE';

export const getStManagementList = (data) => (dispatch) =>
    dispatch(post(getStManagementListUrl, data)).then((res) => {
        dispatch({type: GET_ST_MANAGEMENT_LIST, payload: res});
        return res;
    });

export function queryShipToBySupplyCenterList(shipTo) {
    const url = `${queryShipToBySupplyCenterListUrl}/${shipTo}`;
    const options = {
        method: 'GET',
    };
    const request = () => ({
        type: GET_ST_APPLY_CHANGE_SUPPLY_CENTER_LIST,
        payload: {},
    });
    const success = (response) => {
        return {
            type: GET_ST_APPLY_CHANGE_SUPPLY_CENTER_LIST,
            payload: response,
        };
    };
    const failure = () => ({
        type: GET_ST_APPLY_CHANGE_SUPPLY_CENTER_LIST,
        payload: {},
    });
    return callApi(url, options, request, success, failure);
}
export function getTransportMethodList() {
    const options = {
        method: 'GET',
    };
    const request = () => ({type: GET_ST_TRANSPORT_METHOD_LIST, payload: {}});
    const success = (response) => {
        return {type: GET_ST_TRANSPORT_METHOD_LIST, payload: response};
    };
    const failure = () => ({type: GET_ST_TRANSPORT_METHOD_LIST, payload: {}});
    return callApi(getTransportMethodUrl, options, request, success, failure);
}

export const saveStApplyChange = (params) => post(saveStApplyChangeUrl, params);
